import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertController, Platform } from '@ionic/angular/standalone';
import { environment } from '@environments/environment';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';

//const { NativeMarket } = Plugins;

interface AppUpdate {
  currentAndroid: string;
  currentIos: string;
  androidAppId: string;
  iosAppId: string;
  enabled: boolean;
  msg?: {
    title: string;
    msg: string;
    btn: string;
  };
  majorMsg?: {
    title: string;
    msg: string;
    btn: string;
  };
  minorMsg?: {
    title: string;
    msg: string;
    btn: string;
  }
}

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  updateExample = `${environment.authUrl}/api/auth/clientversion/check`;
  constructor(private http: HttpClient, private alertCtrl: AlertController, 
    private plt: Platform) { }


  async checkForUpdate() {
   
    this.http.get(
    this.updateExample+'?organizationid='+environment.organizationAppId+'&locationId='+environment.locationId)
    .subscribe(async (info: AppUpdate) => {
        // Compare major/minor versions and show according info
        //const versionNumber = await this.appVersion.getVersionNumber();
        const appInfo = await App.getInfo();
        const versionNumber = appInfo.version;
        const splittedVersion = versionNumber.split('.');
         var serverVersion = null;
        if (this.plt.is('android')) {
            serverVersion = info.currentAndroid.split('.');
        }else{
            serverVersion = info.currentIos.split('.');
        }

        // Check Major code, then minor code
        if (serverVersion[0] > splittedVersion[0]) {
          this.presentAlert(info.majorMsg.title, info.majorMsg.msg, info.majorMsg.btn,info.androidAppId,info.iosAppId);
        } else if (serverVersion[1] > splittedVersion[1]) {
          this.presentAlert(info.minorMsg.title, info.minorMsg.msg, info.minorMsg.btn,info.androidAppId,info.iosAppId);
        }

    })
  }

  async openAppstoreEntry(androidAppId,iosAppId) {

    if (this.plt.is('android')) {

      window.open('market://details?id='+androidAppId,'_system', 'location=yes');

    } else {
      await Browser.open({ url: `https://apps.apple.com/app/id${iosAppId}` });
    }

  }

  async presentAlert(header, message, buttonText = '',androidAppId,iosAppId, allowClose = false) {
    const buttons: any = [];

    if (buttonText !== '') {
      buttons.push({
        text: buttonText,
        handler: () => {
          this.openAppstoreEntry(androidAppId,iosAppId);
        }
      });
    }

    if (allowClose) {
      buttons.push({
        text: 'Close',
        role: 'cancel'
      });
    }

    const alert = await this.alertCtrl.create({
      header,
      message,
      buttons,
      backdropDismiss: allowClose
    });

    await alert.present();
  }
}
